<template>
  <PlaceModal
    :value="isDialogOpened"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnApplyFilters
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedPlace"
        @click:close="closeDialog"
      />
    </template>
  </PlaceModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import getPlaceLabel from 'www/vue_components/common/TheFilters/lpu/components/PlaceFilters/functions/getPlaceLabel'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'
import BtnApplyFilters from 'www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue'
import PlaceModal from 'www/vue_components/common/TheFilters/lpu/components/PlaceFilters/components/PlaceModal.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('PlaceFilters')

watch(
  () => filtersStore.filters.place,
  () => {
    const name = getPlaceLabel({ place: filtersStore.filters.place, isChip: true })

    chipsStore.updatePlaceChip({
      name,
      isActive: !!filtersStore.filters.place,
      dropdown: !filtersStore.filters.place,
      truncate: true,
      isVisible: !!name,
      onClick: openDialog,
      onReset: async () => {
        filtersStore.updateFilters({ place: undefined })
        commonStore.updateTownToReferrer()

        await updateLpuListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

function applySelectedPlace() {
  closeDialog()

  if (
    filtersStore.unsavedFilters.place?.isMetro
    && filtersStore.unsavedFilters.place.id !== filtersStore.filters.place?.id
  ) {
    commonStore.updateTownToRegionalCenter()
  } else {
    commonStore.updateTownToReferrer()
  }

  filtersStore.applyUnsavedFilters()

  updateLpuListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
